import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { sortIcon, sortInverse } from 'utils/UriSorting';

const SortableHeaderCell = ({
  header,
  onSort,
  sort,
  sortName
}) => (
  <span>
    <Link to={onSort(sortName, (sort.column === sortName) ? sortInverse(sort.order) : 'desc')}>
      {header}
      {sortIcon(sort, sortName)}
    </Link>
  </span>
);

SortableHeaderCell.propTypes = {
  /** The title of the column */
  header: PropTypes.string,

  /** A function that is called on a column's sortName on click */
  onSort: PropTypes.func,

  /** The selected sort */
  sort: PropTypes.shape({
    column: PropTypes.string,
    order: PropTypes.string
  }),

  /** The string used to define this sort column */
  sortName: PropTypes.string
};

SortableHeaderCell.defaultProps = {
  header: '',
  onSort: () => false,
  sort: {},
  sortName: ''
};

export default SortableHeaderCell;
